module.exports = __webpack_public_path__ + "img/3.d72ea7b6.png";